var map = {
	"./5GAA.png": 168,
	"./CBU.png": 169,
	"./CBU_1.png": 103,
	"./CBU_2.png": 104,
	"./CBU_3.png": 105,
	"./CCSA.png": 170,
	"./EBU.png": 171,
	"./EBU_bg.png": 106,
	"./GSMA.png": 172,
	"./TAF.png": 173,
	"./about.png": 174,
	"./about_3_1.png": 175,
	"./about_3_2.png": 176,
	"./about_3_3.png": 177,
	"./about_3_4.png": 178,
	"./about_3_5.png": 179,
	"./about_3_6.png": 180,
	"./address.png": 181,
	"./cn_black.png": 182,
	"./cn_white.png": 183,
	"./contact.jpg": 184,
	"./contact.png": 185,
	"./download_bg1.png": 186,
	"./email.png": 187,
	"./en_black.png": 188,
	"./en_white.png": 189,
	"./home_logo.gif": 190,
	"./icp.png": 107,
	"./lang_black.png": 191,
	"./lang_white.png": 192,
	"./logo.png": 69,
	"./logo/about_4_0.png": 108,
	"./logo/about_4_1.png": 109,
	"./logo/about_4_10.png": 110,
	"./logo/about_4_11.png": 111,
	"./logo/about_4_12.png": 112,
	"./logo/about_4_13.png": 113,
	"./logo/about_4_2.png": 114,
	"./logo/about_4_3.png": 115,
	"./logo/about_4_4.png": 116,
	"./logo/about_4_5.png": 117,
	"./logo/about_4_6.png": 118,
	"./logo/about_4_7.png": 119,
	"./logo/about_4_8.png": 120,
	"./logo/about_4_9.png": 121,
	"./logo/logo_bg.png": 122,
	"./mobile-images/CBU-1.jpg": 46,
	"./mobile-images/CBU-2.jpg": 47,
	"./mobile-images/CBU-3-1.jpg": 48,
	"./mobile-images/CBU-3.jpg": 49,
	"./mobile-images/CBU-4.jpg": 50,
	"./mobile-images/CBU-5.jpg": 51,
	"./mobile-images/EBU-1.jpg": 52,
	"./mobile-images/EBU-2.jpg": 53,
	"./mobile-images/EBU-3.jpg": 54,
	"./mobile-images/EBU-4.jpg": 55,
	"./mobile-images/EBU-5.png": 56,
	"./mobile-images/about-1.jpg": 123,
	"./mobile-images/about-2.jpg": 124,
	"./mobile-images/about-3.jpg": 125,
	"./mobile-images/about-4.jpg": 126,
	"./mobile-images/about-bg.jpg": 127,
	"./mobile-images/contact-1-bg.jpg": 57,
	"./mobile-images/contact-2-bg.jpg": 58,
	"./mobile-images/logo.gif": 59,
	"./mobile-images/logo.png": 60,
	"./mobile-images/menu.png": 61,
	"./mobile-images/news-1.png": 62,
	"./mobile-images/news-2.png": 63,
	"./mobile-images/news-3.png": 64,
	"./mobile-images/news-4.png": 65,
	"./mobile-images/news-bg.png": 128,
	"./mobile-images/product-bg.jpg": 66,
	"./news.jpg": 193,
	"./news_1.png": 129,
	"./news_2.png": 130,
	"./news_3.png": 131,
	"./news_4.png": 132,
	"./photo.png": 194,
	"./product.jpg": 195,
	"./toTop.png": 27,
	"./wechat.jpg": 133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;